import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#0597A3"
      fillRule="evenodd"
      d="M107 53a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path fill="#0597A3" d="M35.5 114a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path fill="#00D8D8" d="M17.5 48a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M105.058 20.164a1.5 1.5 0 0 1 0 2.121l-9.994 9.994a1.5 1.5 0 1 1-2.122-2.121l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M92.942 20.164a1.5 1.5 0 0 1 2.122 0l9.994 9.994a1.501 1.501 0 0 1-2.122 2.121l-9.994-9.994a1.5 1.5 0 0 1 0-2.121M15.566 72a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 0 1-3 0V73.5a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M7 80.566a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H8.5a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      fillRule="evenodd"
      d="M37.804 16h35.393C75.85 16 78 18.265 78 21.06V89.43C78 92.506 75.633 95 72.713 95h-34.91C35.152 95 33 92.734 33 89.94V21.06c0-2.795 2.15-5.06 4.804-5.06"
      clipRule="evenodd"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M41 88.25A2.25 2.25 0 0 1 43.25 86h26.503a2.25 2.25 0 0 1 0 4.5H43.25A2.25 2.25 0 0 1 41 88.25"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M56.793 33.659a2.25 2.25 0 0 1 0 3.182L44.841 48.793a2.25 2.25 0 1 1-3.182-3.182l11.952-11.952a2.25 2.25 0 0 1 3.182 0M71.255 50.374a2.25 2.25 0 0 1 0 3.182L59.303 65.508a2.25 2.25 0 0 1-3.182-3.182l11.952-11.952a2.25 2.25 0 0 1 3.182 0M69.791 35.877a2.25 2.25 0 0 1 0 3.182L45.107 63.743a2.25 2.25 0 0 1-3.182-3.182L66.61 35.877a2.25 2.25 0 0 1 3.182 0"
      clipRule="evenodd"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M48 23.25c0-1.243 1.051-2.25 2.348-2.25h11.304C62.949 21 64 22.007 64 23.25s-1.051 2.25-2.348 2.25H50.348C49.051 25.5 48 24.493 48 23.25"
      clipRule="evenodd"
    />
    <g clipPath="url(#enrichedIcon-MobilePaymentInverted_svg__a)">
      <path
        fill="#00D8D8"
        d="M54 94.67c0 2.95 2.35 5.33 5.25 5.33h31.5c2.9 0 5.25-2.39 5.25-5.33v-16H54z"
      />
      <path
        fill="#001A43"
        d="M90.75 68h-31.5c-2.9 0-5.25 2.39-5.25 5.33v5.33h42v-5.33c0-2.95-2.35-5.33-5.25-5.33M87 92.25h-5c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h5c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
      />
    </g>
    <defs>
      <clipPath id="enrichedIcon-MobilePaymentInverted_svg__a">
        <path fill="#fff" d="M54 68h42v32H54z" />
      </clipPath>
    </defs>
  </svg>
);
const SvgEnrichedIconMobilePaymentInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconMobilePaymentInverted);
export default Memo;
